import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { API, adminApi } from "./AdminDashboard";

const inputCls = "w-full rounded-xl bg-white/70 border border-[#E2E8E4] px-4 py-2.5 text-sm text-[#1A2F24] focus:outline-none focus:border-[#F4A261] transition-colors duration-300";

const StatsTab = () => {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/stats`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  const update = (i, field, value) => {
    setItems((prev) => prev.map((it, idx) => idx === i ? { ...it, [field]: field === "value" ? Number(value) || 0 : value } : it));
  };

  const save = async () => {
    setSaving(true);
    try {
      await adminApi().put(`${API}/admin/stats`, { items });
      toast.success("Impact numbers updated. They are live on the homepage.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not save.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl rounded-2xl border border-[#E2E8E4] bg-[#F2F4F0] p-7" data-testid="admin-stats-tab">
      <h3 className="font-display text-2xl text-[#1A2F24]">Impact Numbers</h3>
      <p className="mt-2 text-sm text-[#5C7368]">These appear in the "Harvest So Far" section of the homepage.</p>
      <div className="mt-6 space-y-4">
        {items.map((it, i) => (
          <div key={i} className="grid grid-cols-12 gap-3 items-center" data-testid={`admin-stat-row-${i}`}>
            <input value={it.label} onChange={(e) => update(i, "label", e.target.value)} data-testid={`admin-stat-label-${i}`} className={`${inputCls} col-span-7`} />
            <input type="number" min="0" value={it.value} onChange={(e) => update(i, "value", e.target.value)} data-testid={`admin-stat-value-${i}`} className={`${inputCls} col-span-3`} />
            <input value={it.suffix} onChange={(e) => update(i, "suffix", e.target.value)} data-testid={`admin-stat-suffix-${i}`} className={`${inputCls} col-span-2`} placeholder="+" />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving || items.length === 0} data-testid="admin-stats-save"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1E352A] text-[#FAF9F6] px-6 py-2.5 text-xs tracking-[0.12em] uppercase transition-colors duration-300 hover:bg-[#F4A261] hover:text-white disabled:opacity-60">
        {saving ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} />} Save Numbers
      </button>
    </div>
  );
};

export default StatsTab;
